<template>
  <responsive-drawer-header :color="color" :headerBg="theme.appBar.other.bg">
    <template v-slot:drawer-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      <div class="caption">{{ $t('module.messaging.dialog.subtitle') }}</div>
    </template>

    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div>
        {{ title }}
      </div>
    </template>

    <template v-slot:right>
      <v-avatar v-if="openChat" size="35" :color="avatar && theme.avatarBg" class="mr-2">
        <img v-if="avatar" :src="avatar" :alt="title" />
        <v-icon v-else-if="openChat.isGroup">mdi-account-group</v-icon>
        <v-icon v-else>mdi-account-circle</v-icon>
      </v-avatar>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import config from '@/common/config';
import messagingUtil from './messagingUtil';

export default {
  name: 'MessagingHeader',
  mixins: [common, dateTimeMixin],
  components: { ResponsiveDrawerHeader },
  data: () => ({ config }),
  computed: {
    ...mapState('messaging', ['dataLoaded', 'userId', 'userById', 'openChat', 'selectedReceiver']),
    color() {
      return this.theme.appBar.other.color;
    },
    isDebug() {
      return process.env.NODE_ENV === 'dev_';
    },
    title() {
      if (!this.dataLoaded) return;
      if (this.selectedReceiver && this.selectedReceiver.userId) {
        let receiver = this.userById[this.selectedReceiver.userId];
        let currentUser = this.userById[this.userId];
        if (!currentUser) return this.isDebug ? `${this.selectedReceiver.name} (${receiver.id})} ` : `${this.selectedReceiver.name}`;
        let currentUserName = messagingUtil.getNameFromUserObject(currentUser);

        return this.isDebug
          ? `${currentUserName}(${currentUser.id}) => ${this.selectedReceiver.name} (${receiver.id})} `
          : `${currentUserName} => ${this.selectedReceiver.name}`;
      }
      return this.selectedReceiver ? 'Gruppe ' + this.selectedReceiver.name : this.$t('menu.module.messaging');
    },
    avatar() {
      if (this.openChat && !this.openChat.isGroup && this.openChat.counterpart.avatar !== undefined) {
        return this.config.apiUrl + '/medias' + this.openChat.counterpart.avatar;
      } else {
        return undefined;
      }
    },
  },
};
</script>
